export default {
  getNotifications: state => state.notifications,
  getDefaultDuration: state => state.defaultDuration
}

